import styled from "styled-components";

export const Container = styled.div<{isLookDown:boolean}>`
    width: 100%;
    height: 100%;
    position: relative;
    overflow : hidden;
    ${(props) => props.isLookDown ?
        `form{
            display : flex;
            flex-direction : column;
            .condition_chart{
                display : flex;
                flex-directon : row;
            }
            .condition_container{               
                // display : grid;
                // grid-template-columns : repeat(1, 1fr);
                // grid-template-rows : repeat(2, 1fr);
                // div:nth-child(2){
                //     grid-column: 1/2;
                //     grid-row : 2/3;
                // }
                // div:nth-child(3){
                //     grid-column: 1/2;
                //     grid-row : 3;
                // }
                display: flex;
                flex-direction: column;
                gap: 10px;
            }
            .tableForm{
                height:100%;
                margin : -450px 0px 0px 260px;
                div div:nth-child(2){
                    div:nth-child(1){
                        table{
                            height : 420px;
                        }
                    }
                }
            }
        }`   
        :
        `form{
            display : flex;
            flex-direction : column-reverse;
            .condition_container{
                visibility: hidden;
                height : 0px;
                } 
        }`
    }

    .chart-container{
        ${(props) => props.isLookDown ?
            `
            padding-top: 10px;
            padding-left: 10px;           
            ` 
            : 
            `padding-left: 400px;` 
        };
        .chart-menu{    
        text-align: right;
        margin-right: 22px;
        svg {
            cursor: pointer;
        }
        svg:hover {
            opacity: 0.7;
        }
        }
        .charts {
        display: flex;
        flex-direction: ${(props) => props.isLookDown ?`column` : `row` };
        justify-content: space-between;
        align-items : center;
        width : auto;
        height : 300px; 
         div {           
            width : 1400px;
            height : 280px;
         }      
        }  
    }
`;